export default ({ spacings, images }) => {
  const styles = {
    modal: {
      display: 'flex',
      flexDirection: 'column',
      width: '50%',
      height: 'auto',
      maxHeight: '350px',
      position: 'fixed',
      top: '35%',
      left: '25%',
      right:'25%',
      background: 'white',
      border: '1px #00B7FF solid', //#00a5ff,
      borderRadius: '5px',
      zIndex: '110',
      boxShadow: '1px 1px rgba(0,165,255,0.5)'
    },
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      background: 'rgba(0,165,255,1)'
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      color: 'white',
      padding: '2px 10px',
      verticalAlign: 'middle'
    },
    closeBtn: {
      width: spacings.x4,
      height: spacings.x2,
      margin: spacings.x2,
      cursor: 'pointer',
      borderRadius: '100%',
      backgroundImage: images.closeIconSella,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '40%'
    },
    'modal--display-none': {
      display: 'none'
    },
    wrapper: {
      display: 'inline-block',
      width: '100%'
    },
    content: {
      padding: '25px 10px',
      marginRight: 'auto',
      marginLeft: 'auto'
    }
  }
  return styles
}



// WEBPACK FOOTER //
// ./components/alertModal/styles.js